export default "__VITE_ASSET__D74iE3IM__"